module.exports = __webpack_public_path__ + "img/certLabBarragan.d70aac50.jpg";